module.exports = __webpack_public_path__ + "static/media/marlene_street_forrest.0f316ec6.pdf";